import { Link, useLocation } from 'react-router-dom';
import { handlePhoneClick } from '../../../utils/trackPhoneCall';
import { siteConfig } from '../../../config/site';
import { climatizacaoServicesList } from '../../../data/climatizacaoServices';
import { zonaDoCaminho } from '../../../data/zonas';

const Footer = () => {
  const { pathname } = useLocation();
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';
  // O rodapé acompanha a localidade em que o visitante está
  const zonaAtual = isClimatizacaoSite
    ? zonaDoCaminho(pathname, climatizacaoServicesList.map((s) => s.slug))
    : undefined;
  const hrefServico = (slug: string) =>
    zonaAtual ? `/${slug}-${zonaAtual.slug}` : `/${slug}`;
  const isDesentupimentosSite = siteConfig.domain === 'alphadesentupimentos.pt';
  const isEletrodomesticosSite = siteConfig.domain === 'alphaservices.pt';
  const isPortoSite = siteConfig.domain === 'alphacanalizacoesporto.pt';

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              {siteConfig.name}
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              {siteConfig.description}
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-blue-400"></i>
                <a href={`tel:${siteConfig.phone}`} onClick={handlePhoneClick} className="hover:text-blue-400 transition-colors">
                  {siteConfig.phoneDisplay}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-blue-400"></i>
                <a href={`mailto:${siteConfig.email}`} className="hover:text-blue-400 transition-colors">
                  {siteConfig.email}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <div>
                  <div>{siteConfig.address.street}</div>
                  <div>{siteConfig.address.postalCode} {siteConfig.address.city}, {siteConfig.address.country}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Services (Oculto para Eletrodomésticos se solicitado) */}
          {!isEletrodomesticosSite && (
            <div>
              <h4 className="text-lg font-semibold mb-4">Serviços</h4>
              <ul className="space-y-2 text-gray-300">
                {siteConfig.domain === 'alphaclean.pt' ? (
                  <>
                    <li><Link to="/limpeza-condominios" className="hover:text-white transition-colors">Limpeza de Condomínios</Link></li>
                    <li><Link to="/limpeza-pos-obra" className="hover:text-white transition-colors">Limpeza Pós-Obra</Link></li>
                    <li><Link to="/limpeza-escritorios" className="hover:text-white transition-colors">Limpeza de Escritórios</Link></li>
                    <li><Link to="/limpeza-residencial" className="hover:text-white transition-colors">Limpeza Residencial</Link></li>
                    <li><Link to="/limpeza-alojamento-local" className="hover:text-white transition-colors">Limpeza de Alojamento Local</Link></li>
                    <li><Link to="/limpeza-restaurantes" className="hover:text-white transition-colors">Limpeza de Restaurantes</Link></li>
                    <li><Link to="/limpeza-lojas-comercio" className="hover:text-white transition-colors">Limpeza de Lojas e Comércio</Link></li>
                  </>
                ) : isClimatizacaoSite ? (
                  <>
                    {zonaAtual && (
                      <li className="text-xs font-semibold uppercase tracking-wide text-gray-500 pb-1">
                        {zonaAtual.preposicao} {zonaAtual.nome}
                      </li>
                    )}
                    {climatizacaoServicesList.map((servico) => (
                      <li key={servico.id}>
                        <Link to={hrefServico(servico.slug)} className="hover:text-white transition-colors">
                          {zonaAtual ? `${servico.tituloLocal} ${zonaAtual.preposicao} ${zonaAtual.nome}` : servico.tituloLocal}
                        </Link>
                      </li>
                    ))}
                    <li><Link to="/zonas" className="hover:text-white transition-colors">Zonas Atendidas</Link></li>
                  </>
                ) : isDesentupimentosSite ? (
                  <>
                    <li><Link to="/servico/esgotos" className="hover:text-white transition-colors">Desentupimento de Esgotos</Link></li>
                    <li><Link to="/servico/sanitas" className="hover:text-white transition-colors">Desentupimento de Sanitas</Link></li>
                    <li><Link to="/servico/lavatorios-pias" className="hover:text-white transition-colors">Desentupimento de Lavatórios e Pias</Link></li>
                    <li><Link to="/servico/colunas-prediais" className="hover:text-white transition-colors">Desentupimento de Colunas Prediais</Link></li>
                    <li><Link to="/servico/hidrojato" className="hover:text-white transition-colors">Desentupimento com Hidrojato</Link></li>
                    <li><Link to="/servico/video-inspecao" className="hover:text-white transition-colors">Vídeo Inspeção de Tubulações</Link></li>
                  </>
                ) : (siteConfig.domain === 'alphaeletrica.pt' || siteConfig.domain === 'alphaeletric.pt') ? (
                  <>
                    <li><Link to="/servico/instalacao-eletrica" className="hover:text-white transition-colors">Instalação Elétrica</Link></li>
                    <li><Link to="/servico/reparacao-eletrica" className="hover:text-white transition-colors">Reparação de Avarias</Link></li>
                    <li><Link to="/servico/quadro-eletrico" className="hover:text-white transition-colors">Quadros Elétricos</Link></li>
                    <li><Link to="/servico/iluminacao" className="hover:text-white transition-colors">Iluminação LED</Link></li>
                    <li><Link to="/servico/climatizacao-automacao" className="hover:text-white transition-colors">Climatização</Link></li>
                    <li><Link to="/servico/reparacao-ar-condicionado" className="hover:text-white transition-colors">Reparação de Ar Condicionado</Link></li>
                    <li><Link to="/servico/certificacao" className="hover:text-white transition-colors">Certificações</Link></li>
                  </>
                ) : (
                  <>
                    <li><Link to="/servico/fugas" className="hover:text-white transition-colors">Detecção de Fugas</Link></li>
                    <li><Link to="/servico/reparacao" className="hover:text-white transition-colors">Reparação de Canalização</Link></li>
                    <li><Link to="/servico/instalacao" className="hover:text-white transition-colors">Instalação de Canalização</Link></li>
                    <li><Link to="/servico/manutencao" className="hover:text-white transition-colors">Manutenção Preventiva</Link></li>
                    <li><Link to="/servico/remodelacao" className="hover:text-white transition-colors">Remodelação de Casas de Banho</Link></li>
                    {isPortoSite && (
                      <li><Link to="/pintura-pladur" className="hover:text-white transition-colors">Pintura e Pladur</Link></li>
                    )}
                  </>
                )}
              </ul>
            </div>
          )}

          {/* Areas */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Zonas Atendidas</h4>
            <ul className="space-y-2 text-gray-300">
              {siteConfig.address.city === 'Porto' ? (
                <>
                  <li>Porto</li>
                  <li>Vila Nova de Gaia</li>
                  <li>Matosinhos</li>
                  <li>Gondomar</li>
                  <li>Valongo</li>
                  <li>Maia</li>
                  <li className="text-blue-400">+ Muitas outras zonas</li>
                </>
              ) : (
                <>
                  <li>Lisboa</li>
                  <li>Amadora</li>
                  <li>Oeiras</li>
                  <li>Almada</li>
                  <li>Seixal</li>
                  <li>Setúbal</li>
                  <li className="text-blue-400">+ Muitas outras zonas</li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm">
              © 2025 {siteConfig.name}. Todos os direitos reservados.
            </div>
            <div className="flex flex-wrap gap-6 text-sm">
              {isEletrodomesticosSite ? (
                null
              ) : (
                <>
                  <Link to="/sobre-nos" className="text-gray-400 hover:text-white transition-colors">Sobre Nós</Link>
                  {!isClimatizacaoSite && (
                    <Link to="/contato" className="text-gray-400 hover:text-white transition-colors">Contato</Link>
                  )}
                </>
              )}
              <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-white transition-colors">
                Política de Privacidade
              </Link>
              <a
                href="https://foturemarketing.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                desenvolvido por foturemarketing.com
              </a>
            </div>
          </div>
          <div className="text-center mt-4 text-xs text-gray-500">
            Cumprimos RGPD. Dados usados apenas para resposta ao seu pedido.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
